<template>
  <div>
    <div class="intro-x flex items-center h-10">
      <h2 class="text-lg font-medium truncate mr-5">
        {{ $t('dashboard.transactionsBetweenAccounts') }}
      </h2>
    </div>
    <div class="mt-5">
      <div v-for="(item, index) in transactions" :key="index" class="intro-x">
        <div class="box px-5 py-3 mb-3 flex items-center zoom-in">
          <div class="flex-1 overflow-hidden">
            <div class="font-medium truncate">
              {{ item.account }}
            </div>
            <div class="text-gray-600 text-xs">
              {{ item.date }}
            </div>
          </div>
          <div :class="['flex-1 text-right', item.isIncome ? 'text-theme-9' : 'text-theme-6']">
            {{ item.amount | currency }}
          </div>
        </div>
      </div>
      <!-- <div
        class="intro-x w-full block text-center rounded-md py-3 border border-dotted border-theme-15 dark:border-dark-5 text-theme-16 dark:text-gray-600"
      >
        {{ $t('text.seeMore') }}
      </div> -->
    </div>
  </div>
</template>

<script>
export default {
  props: {
    report: Object,
  },

  computed: {
    transactions() {
      if (this.report.transaction?.account) {
        return this.report.transaction.account.map(item => {
          return {
            amount: item.income > 0 ? item.income : item.expense,
            account: item.bankAccount,
            date: item.transactionDate,
            isIncome: item.income > 0,
          };
        });
      }
      return [];
    },
  },
};
</script>
